import { getsessioncounter } from "./getsessioncounter";
import { Globals } from "../CoreApp/Globals";

export function getsessioninfo() {
  Globals._sessionCounter++;
  return "&sk=" + Globals._sessionKey + "&zc=" + getsessioncounter(); // gSessionCounter.toString(); //
}
